import { type ReactNode } from 'react';
import { StatCard } from '@/components/ui/stat-card';
import { useAuth } from '@/hooks/use-auth';
import { usePersonalStats } from '@/hooks/use-personal-stats';

export function PersonalStatsRow(): ReactNode {
  const { user } = useAuth();
  const { data } = usePersonalStats(user?.id);
  return (
    <div className="grid grid-cols-2 gap-sm sm:grid-cols-4">
      <StatCard label="Total" value={data?.total ?? 0} accent />
      <StatCard label="Hoy" value={data?.today ?? 0} />
      <StatCard label="Semana" value={data?.week ?? 0} />
      <StatCard label="Mes" value={data?.month ?? 0} />
    </div>
  );
}
